import React from 'react';
import './Features.css';

function Features() {
  const features = [
    {
      title: "70% Payment Guarantee",
      description: "We guarantee at least 70% of payment within 6 months.",
      icon: "💰"
    },
    {
      title: "Unified Payment Tracking",
      description: "Track all your pending payments and claims in one place.",
      icon: "📊"
    },
    {
      title: "Cashflow Predictions",
      description: "Predict monthly, weekly and yearly cashflow.",
      icon: "📈"
    },
    {
      title: "System Integration",
      description: "Seamlessly connect to disparate accounting systems.",
      icon: "🔄"
    }
  ];

  return (
    <section className="features-section">
      <div className="features-container">
        <h2 className="features-title">Why Choose PayAssured</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features; 